<div style="overflow-x: auto">
  <table
    mat-table
    [dataSource]="tableDataSource"
    class="table"
    id="custom__table"
  >
    <ng-container
      *ngFor="let tableColumn of tableColumns"
      [matColumnDef]="tableColumn?.name"
    >
      <th mat-header-cell *matHeaderCellDef>
        {{ tableColumn?.name }}
      </th>
      <ng-container
        *ngIf="tableColumn?.isActionColumn === true; else elseTemplate"
      >
        <td
          mat-cell
          *matCellDef="let element"
          [class.text-right]="tableColumn.position == 'right'"
        >
          <ng-container *ngIf="tableColumn?.actionType === 'button'; else imageTemplate">
            <button
              class="action-button"
              (click)="handleActionClick(tableColumn.dataKey, element, $event)"
            >
              {{ tableColumn.actionLabel || tableColumn.name }}
            </button>
          </ng-container>
          <ng-template #imageTemplate>
          <img [src]="tableColumn?.dataKey" alt="" />
          </ng-template>
        </td>
      </ng-container>
      <ng-template #elseTemplate>
        <td
          mat-cell
          *matCellDef="let element; let i = index"
          (click)="handleRowClick(element)"
          class="pointer"
        >
          <span *ngIf="tableColumn.dataType === 'string'">
            <span
              [ngClass]="
                tableColumn.embolden ? 'table__major-text' : 'table__minor-text'
              "
            >
              <span *ngIf="tableColumn?.dataKey === 'tableId'"
                >Table &nbsp;</span
              >
              {{ toString(element[tableColumn.dataKey]) || '--' | titlecase }}
            </span>
          </span>
          <span
            *ngIf="tableColumn.dataType === 'date'"
            class="table__minor-text"
          >
            <ng-container
              *ngIf="element[tableColumn.dataKey] !== null; else elseTemplate"
            >
              {{ element[tableColumn.dataKey] | date : 'medium' }}
            </ng-container>
            <ng-template #elseTemplate> -- </ng-template>
          </span>
          <span
            *ngIf="tableColumn.dataType === 'number'"
            class="table__minor-text"
          >
            <span *ngIf="tableColumn?.dataKey === 'id'">#</span>
            <span *ngIf="tableColumn?.isMoney; else notMoney">
              {{ element[tableColumn.dataKey] | currency : '₦' }}
            </span>
            <ng-template #notMoney>
              {{ element[tableColumn.dataKey] || '0' | number }}
            </ng-template>
          </span>

          <ng-container *ngIf="tableColumn?.isDishes">
            <div *ngFor="let dish of element[tableColumn?.dataKey]" class="dish-container">
              <span class="dish-name">{{ dish.name | titlecase }} (x{{ dish.quantity }})</span>
              <div *ngIf="dish.addons && dish.addons.length > 0" class="addons">
                <span>Add-on: 
                  <span *ngFor="let addon of dish.addons; let last = last">
                    {{ addon.name | titlecase }}<span *ngIf="addon.quantity"> (x{{ addon.quantity }})</span><span *ngIf="!last">, </span>
                  </span>
                </span>
              </div>
            </div>
          </ng-container>
        </td>
      </ng-template>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns; let j = index"
    ></tr>
  </table>
</div>
